import React from "react";
import { Outlet } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { VideoProvider } from "../features/video/providers/VideoContext";
import { VideoUIProvider } from "../features/videoUI/VideoUIContext";
import { TrackingProvider } from "@core/features/tracking";
import { stopAllTrackedStreams, forceStopAllMediaStreams } from "../features/video/utils/stopChimeStreams";
import { DashboardHeaderContainer } from "@platform/layouts/DashboardHeader";
import { DashboardNavigationItemsContainer } from "@platform/layouts/DashboardNavigation";

export type Props = {
  isWithNavigation?: boolean;
};

export function VideoEndLayout({ isWithNavigation = false }: Props) {
  // Clean up media streams when this layout loads (video/end page)
  React.useEffect(() => {
    // First stop tracked streams, then force stop any remaining
    stopAllTrackedStreams();
    forceStopAllMediaStreams();
  }, []);

  return (
    <>
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1"
        />
      </Helmet>
      <TrackingProvider
        debug={{ enabled: false }}
        services={{ posthog: true, google_analytics: true }}
      >
        <VideoProvider>
          <VideoUIProvider>
            {isWithNavigation ? (
              <div className="min-h-[100dvh] flex flex-col bg-brand-50 text-brand-800">
                <DashboardHeaderContainer>
                  <DashboardNavigationItemsContainer />
                </DashboardHeaderContainer>
                <main className="flex flex-1 h-full justify-center items-center">
                  <Outlet />
                </main>
              </div>
            ) : (
              <main className="flex-grow flex flex-col bg-brand-50 h-full min-h-[100dvh]">
                <Outlet />
              </main>
            )}
          </VideoUIProvider>
        </VideoProvider>
      </TrackingProvider>
    </>
  );
}

export default VideoEndLayout;
